module.exports = __webpack_public_path__ + "img/empreendimento-logo-5.7f40dfac.png";